import React from 'react';
import { Modal, Form, Select, DatePicker, Button } from 'antd';
import { SubscriptionLevel } from '../Types/SubscriptionLevel';
import { mapSubscriptionLevel } from '../Mappers/mapSubscriptionLevel';
import dayjs from 'dayjs';

interface Props {
    visible: boolean;
    onCancel: () => void;
    onSubmit: (values: { subscriptionLevel: SubscriptionLevel; date: string }) => void;
    initialLevel: SubscriptionLevel;
    initialDate: string;
}

const subscriptionOptions = Object.values(SubscriptionLevel)
    .filter((v) => typeof v === 'number')
    .map((level) => ({
        value: level as SubscriptionLevel,
        label: mapSubscriptionLevel(level as SubscriptionLevel),
    }));

const AdminSubscriptionForm: React.FC<Props> = ({ visible, onCancel, onSubmit, initialLevel, initialDate }) => {
    const [form] = Form.useForm();

    React.useEffect(() => {
        form.setFieldsValue({
            subscriptionLevel: initialLevel,
            date: initialDate ? dayjs(initialDate) : undefined,
        });
    }, [initialLevel, initialDate, form]);

    const handleFinish = (values: any) => {
        // Convert dayjs to string (YYYY-MM-DD)
        onSubmit({
            subscriptionLevel: values.subscriptionLevel,
            date: values.date ? values.date.format('YYYY-MM-DD') : '',
        });
    };

    return (
        <Modal
            open={visible}
            title="Update Subscription"
            onCancel={onCancel}
            footer={null}
            destroyOnClose
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleFinish}
                initialValues={{ subscriptionLevel: initialLevel, date: initialDate ? dayjs(initialDate) : undefined }}
            >
                <Form.Item
                    name="subscriptionLevel"
                    label="Subscription Level"
                    rules={[{ required: true, message: 'Please select a subscription level' }]}
                >
                    <Select options={subscriptionOptions} />
                </Form.Item>
                <Form.Item
                    name="date"
                    label="Next Subscription Date"
                    rules={[{ required: true, message: 'Please select a date' }]}
                >
                    <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit" style={{ marginRight: 8 }}>
                        Save
                    </Button>
                    <Button onClick={onCancel}>Cancel</Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default AdminSubscriptionForm;
